<template>
  <div :class="classModifiers">
    <div @click.stop="onClickNumber">
      <span class="market-shares-bar__number">{{ number.toLocaleString() }}</span>
      <span class="market-shares-bar__mode">{{ mode }}</span>
    </div>
    <div class="market-shares-bar__bottom">
      <span class="market-shares-bar__info">
        at <span v-price-display.cents="average"></span> avg.
      </span>
      <div class="market-shares-bar__change-price-wrap">
        <market-change-price :price="difference"></market-change-price>
      </div>
    </div>
  </div>
</template>

<script src="./market-shares-bar.js"></script>
<style src="./market-shares-bar.scss" lang="scss"></style>
